import { render, staticRenderFns } from "./SalesCounterInvoices.vue?vue&type=template&id=35493497"
import script from "./SalesCounterInvoices.vue?vue&type=script&lang=js"
export * from "./SalesCounterInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports